// extracted by mini-css-extract-plugin
module.exports = {"cancelButton":"UpdateAwsCertificate_cancelButton__2xQMJ"};